/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

export const animationsList = [
	{
		label: __( 'None', 'vayu-blocks' ),
		value: 'none'
	},
	{
		label: __( 'Back In Down', 'vayu-blocks' ),
		value: 'backInDown'
	},
	{
		label: __( 'Back In Left', 'vayu-blocks' ),
		value: 'backInLeft'
	},
	{
		label: __( 'Back In Right', 'vayu-blocks' ),
		value: 'backInRight'
	},
	{
		label: __( 'Back In Up', 'vayu-blocks' ),
		value: 'backInUp'
	},
	{
		label: __( 'Bounce', 'vayu-blocks' ),
		value: 'bounce'
	},
	{
		label: __( 'Bounce In', 'vayu-blocks' ),
		value: 'bounceIn'
	},
	{
		label: __( 'Bounce In Down', 'vayu-blocks' ),
		value: 'bounceInDown'
	},
	{
		label: __( 'Bounce In Left', 'vayu-blocks' ),
		value: 'bounceInLeft'
	},
	{
		label: __( 'Bounce In Right', 'vayu-blocks' ),
		value: 'bounceInRight'
	},
	{
		label: __( 'Bounce In Up', 'vayu-blocks' ),
		value: 'bounceInUp'
	},
	{
		label: __( 'Fade In', 'vayu-blocks' ),
		value: 'fadeIn'
	},
	{
		label: __( 'Fade In Down', 'vayu-blocks' ),
		value: 'fadeInDown'
	},
	{
		label: __( 'Fade In Down Big', 'vayu-blocks' ),
		value: 'fadeInDownBig'
	},
	{
		label: __( 'Fade In Left', 'vayu-blocks' ),
		value: 'fadeInLeft'
	},
	{
		label: __( 'Fade In Left Big', 'vayu-blocks' ),
		value: 'fadeInLeftBig'
	},
	{
		label: __( 'Fade In Right', 'vayu-blocks' ),
		value: 'fadeInRight'
	},
	{
		label: __( 'Fade In Right Big', 'vayu-blocks' ),
		value: 'fadeInRightBig'
	},
	{
		label: __( 'Fade In Up', 'vayu-blocks' ),
		value: 'fadeInUp'
	},
	{
		label: __( 'Fade In Top Left', 'vayu-blocks' ),
		value: 'fadeInTopLeft'
	},
	{
		label: __( 'Fade In Top Right', 'vayu-blocks' ),
		value: 'fadeInTopRight'
	},
	{
		label: __( 'Fade In Bottom Left', 'vayu-blocks' ),
		value: 'fadeInBottomLeft'
	},
	{
		label: __( 'Fade In Bottom Right', 'vayu-blocks' ),
		value: 'fadeInBottomRight'
	},
	{
		label: __( 'Flip', 'vayu-blocks' ),
		value: 'flip'
	},
	{
		label: __( 'Flip In X', 'vayu-blocks' ),
		value: 'flipInX'
	},
	{
		label: __( 'Flip In Y', 'vayu-blocks' ),
		value: 'flipInY'
	},
	{
		label: __( 'Rotate In', 'vayu-blocks' ),
		value: 'rotateIn'
	},
	{
		label: __( 'Rotate In Down Left', 'vayu-blocks' ),
		value: 'rotateInDownLeft'
	},
	{
		label: __( 'Rotate In Down Right', 'vayu-blocks' ),
		value: 'rotateInDownRight'
	},
	{
		label: __( 'Rotate In Up Left', 'vayu-blocks' ),
		value: 'rotateInUpLeft'
	},
	{
		label: __( 'Rotate In Up Right', 'vayu-blocks' ),
		value: 'rotateInUpRight'
	},
	{
		label: __( 'Slide In Down', 'vayu-blocks' ),
		value: 'slideInDown'
	},
	{
		label: __( 'Slide In Left', 'vayu-blocks' ),
		value: 'slideInLeft'
	},
	{
		label: __( 'Slide In Right', 'vayu-blocks' ),
		value: 'slideInRight'
	},
	{
		label: __( 'Slide In Up', 'vayu-blocks' ),
		value: 'slideInUp'
	},
	{
		label: __( 'Zoom In', 'vayu-blocks' ),
		value: 'zoomIn'
	},
	{
		label: __( 'Zoom In Down', 'vayu-blocks' ),
		value: 'zoomInDown'
	},
	{
		label: __( 'Zoom In Left', 'vayu-blocks' ),
		value: 'zoomInLeft'
	},
	{
		label: __( 'Zoom In Right', 'vayu-blocks' ),
		value: 'zoomInRight'
	},
	{
		label: __( 'Zoom In Up', 'vayu-blocks' ),
		value: 'zoomInUp'
	},
	{
		label: __( 'Roll In', 'vayu-blocks' ),
		value: 'rollIn'
	},
	{
		label: __( 'Light Speed In Right', 'vayu-blocks' ),
		value: 'lightSpeedInRight'
	},
	{
		label: __( 'Light Speed In Left', 'vayu-blocks' ),
		value: 'lightSpeedInLeft'
	},
	{
		label: __( 'Flash', 'vayu-blocks' ),
		value: 'flash'
	},
	{
		label: __( 'Pulse', 'vayu-blocks' ),
		value: 'pulse'
	},
	{
		label: __( 'Rubber Band', 'vayu-blocks' ),
		value: 'rubberBand'
	},
	{
		label: __( 'Shake X', 'vayu-blocks' ),
		value: 'shakeX'
	},
	{
		label: __( 'Shake Y', 'vayu-blocks' ),
		value: 'shakeY'
	},
	{
		label: __( 'Head Shake', 'vayu-blocks' ),
		value: 'headShake'
	},
	{
		label: __( 'Swing', 'vayu-blocks' ),
		value: 'swing'
	},
	{
		label: __( 'TaDa', 'vayu-blocks' ),
		value: 'tada'
	},
	{
		label: __( 'Wobble', 'vayu-blocks' ),
		value: 'wobble'
	},
	{
		label: __( 'Jello', 'vayu-blocks' ),
		value: 'jello'
	},
	{
		label: __( 'Heart Beat', 'vayu-blocks' ),
		value: 'heartBeat'
	},
	{
		label: __( 'Hinge', 'vayu-blocks' ),
		value: 'hinge'
	},
	{
		label: __( 'Jack In The Box', 'vayu-blocks' ),
		value: 'jackInTheBox'
	}
];

export const categories = [
	{
		label: __( 'Backing', 'vayu-blocks' ),
		value: 'backInDown'
	},
	{
		label: __( 'Bouncing', 'vayu-blocks' ),
		value: 'bounce'
	},
	{
		label: __( 'Fading', 'vayu-blocks' ),
		value: 'fadeIn'
	},
	{
		label: __( 'Flipping', 'vayu-blocks' ),
		value: 'flip'
	},
	{
		label: __( 'Rotating', 'vayu-blocks' ),
		value: 'rotateIn'
	},
	{
		label: __( 'Sliding', 'vayu-blocks' ),
		value: 'slideInDown'
	},
	{
		label: __( 'Zooming', 'vayu-blocks' ),
		value: 'zoomIn'
	},
	{
		label: __( 'Rolling', 'vayu-blocks' ),
		value: 'rollIn'
	},
	{
		label: __( 'Light Speed', 'vayu-blocks' ),
		value: 'lightSpeedInRight'
	},
	{
		label: __( 'Other', 'vayu-blocks' ),
		value: 'flash'
	}
];

export const outAnimation = [
	'backOutDown',
	'backOutLeft',
	'backOutRight',
	'backOutUp',
	'bounceOut',
	'bounceOutDown',
	'bounceOutLeft',
	'bounceOutRight',
	'bounceOutUp',
	'fadeOut',
	'fadeOutDown',
	'fadeOutDownBig',
	'fadeOutLeft',
	'fadeOutLeftBig',
	'fadeOutRight',
	'fadeOutRightBig',
	'fadeOutUp',
	'fadeOutUpBig',
	'fadeOutTopLeft',
	'fadeOutTopRight',
	'fadeOutBottomRight',
	'fadeOutBottomLeft',
	'flipOutX',
	'flipOutY',
	'lightSpeedOutRight',
	'lightSpeedOutLeft',
	'rotateOut',
	'rotateOutDownLeft',
	'rotateOutDownRight',
	'rotateOutUpLeft',
	'rotateOutUpRight',
	'slideOutDown',
	'slideOutLeft',
	'slideOutRight',
	'slideOutUp',
	'zoomOut',
	'zoomOutDown',
	'zoomOutLeft',
	'zoomOutRight',
	'zoomOutUp',
	'rollOut'
];

export const delayList = [
	{
		label: __( 'None', 'vayu-blocks' ),
		value: 'none'
	},
	{
		label: __( '100 Milliseconds', 'vayu-blocks' ),
		value: 'delay-100ms'
	},
	{
		label: __( '200 Milliseconds', 'vayu-blocks' ),
		value: 'delay-200ms'
	},
	{
		label: __( '500 Milliseconds', 'vayu-blocks' ),
		value: 'delay-500ms'
	},
	{
		label: __( 'One Second', 'vayu-blocks' ),
		value: 'delay-1s'
	},
	{
		label: __( 'Two Second', 'vayu-blocks' ),
		value: 'delay-2s'
	},
	{
		label: __( 'Three Second', 'vayu-blocks' ),
		value: 'delay-3s'
	},
	{
		label: __( 'Four Second', 'vayu-blocks' ),
		value: 'delay-4s'
	},
	{
		label: __( 'Five Second', 'vayu-blocks' ),
		value: 'delay-5s'
	}
];

export const speedList = [
	{
		label: __( 'Slow', 'vayu-blocks' ),
		value: 'slow'
	},
	{
		label: __( 'Slower', 'vayu-blocks' ),
		value: 'slower'
	},
	{
		label: __( 'Default', 'vayu-blocks' ),
		value: 'none'
	},
	{
		label: __( 'Fast', 'vayu-blocks' ),
		value: 'fast'
	},
	{
		label: __( 'Faster', 'vayu-blocks' ),
		value: 'faster'
	}
];
